/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LeaguePlayoffConfig } from './LeaguePlayoffConfig';
import {
    LeaguePlayoffConfigFromJSON,
    LeaguePlayoffConfigFromJSONTyped,
    LeaguePlayoffConfigToJSON,
    LeaguePlayoffConfigToJSONTyped,
} from './LeaguePlayoffConfig';
import type { LeagueDivisionResponse } from './LeagueDivisionResponse';
import {
    LeagueDivisionResponseFromJSON,
    LeagueDivisionResponseFromJSONTyped,
    LeagueDivisionResponseToJSON,
    LeagueDivisionResponseToJSONTyped,
} from './LeagueDivisionResponse';
import type { GlobalFilterExclusion } from './GlobalFilterExclusion';
import {
    GlobalFilterExclusionFromJSON,
    GlobalFilterExclusionFromJSONTyped,
    GlobalFilterExclusionToJSON,
    GlobalFilterExclusionToJSONTyped,
} from './GlobalFilterExclusion';
import type { LeagueStatus } from './LeagueStatus';
import {
    LeagueStatusFromJSON,
    LeagueStatusFromJSONTyped,
    LeagueStatusToJSON,
    LeagueStatusToJSONTyped,
} from './LeagueStatus';
import type { TiebreakerConfig } from './TiebreakerConfig';
import {
    TiebreakerConfigFromJSON,
    TiebreakerConfigFromJSONTyped,
    TiebreakerConfigToJSON,
    TiebreakerConfigToJSONTyped,
} from './TiebreakerConfig';
import type { RoundRobinType } from './RoundRobinType';
import {
    RoundRobinTypeFromJSON,
    RoundRobinTypeFromJSONTyped,
    RoundRobinTypeToJSON,
    RoundRobinTypeToJSONTyped,
} from './RoundRobinType';
import type { MatchScoringMode } from './MatchScoringMode';
import {
    MatchScoringModeFromJSON,
    MatchScoringModeFromJSONTyped,
    MatchScoringModeToJSON,
    MatchScoringModeToJSONTyped,
} from './MatchScoringMode';
import type { LeaguePointsConfig } from './LeaguePointsConfig';
import {
    LeaguePointsConfigFromJSON,
    LeaguePointsConfigFromJSONTyped,
    LeaguePointsConfigToJSON,
    LeaguePointsConfigToJSONTyped,
} from './LeaguePointsConfig';
import type { MatchFormat } from './MatchFormat';
import {
    MatchFormatFromJSON,
    MatchFormatFromJSONTyped,
    MatchFormatToJSON,
    MatchFormatToJSONTyped,
} from './MatchFormat';
import type { LeagueMatchdayResponse } from './LeagueMatchdayResponse';
import {
    LeagueMatchdayResponseFromJSON,
    LeagueMatchdayResponseFromJSONTyped,
    LeagueMatchdayResponseToJSON,
    LeagueMatchdayResponseToJSONTyped,
} from './LeagueMatchdayResponse';
import type { LeagueStanding } from './LeagueStanding';
import {
    LeagueStandingFromJSON,
    LeagueStandingFromJSONTyped,
    LeagueStandingToJSON,
    LeagueStandingToJSONTyped,
} from './LeagueStanding';

/**
 * League data returned from API endpoints
 * @export
 * @interface LeagueResponse
 */
export interface LeagueResponse {
    /**
     * 
     * @type {string}
     * @memberof LeagueResponse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof LeagueResponse
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof LeagueResponse
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof LeagueResponse
     */
    gameId?: string;
    /**
     * 
     * @type {string}
     * @memberof LeagueResponse
     */
    matchModeId?: string;
    /**
     * 
     * @type {string}
     * @memberof LeagueResponse
     */
    ruleSetId?: string;
    /**
     * 
     * @type {string}
     * @memberof LeagueResponse
     */
    sponsorId?: string;
    /**
     * 
     * @type {string}
     * @memberof LeagueResponse
     */
    scoringTemplateId?: string;
    /**
     * 
     * @type {string}
     * @memberof LeagueResponse
     */
    seasonName?: string;
    /**
     * 
     * @type {number}
     * @memberof LeagueResponse
     */
    seasonNumber?: number;
    /**
     * 
     * @type {number}
     * @memberof LeagueResponse
     */
    seasonStartDate?: number;
    /**
     * 
     * @type {number}
     * @memberof LeagueResponse
     */
    seasonEndDate?: number;
    /**
     * 
     * @type {RoundRobinType}
     * @memberof LeagueResponse
     */
    roundRobinType?: RoundRobinType;
    /**
     * 
     * @type {MatchFormat}
     * @memberof LeagueResponse
     */
    matchFormat?: MatchFormat;
    /**
     * 
     * @type {MatchScoringMode}
     * @memberof LeagueResponse
     */
    scoringMode?: MatchScoringMode;
    /**
     * 
     * @type {LeaguePointsConfig}
     * @memberof LeagueResponse
     */
    pointsConfig?: LeaguePointsConfig;
    /**
     * 
     * @type {TiebreakerConfig}
     * @memberof LeagueResponse
     */
    tiebreakerConfig?: TiebreakerConfig;
    /**
     * 
     * @type {LeaguePlayoffConfig}
     * @memberof LeagueResponse
     */
    playoffConfig?: LeaguePlayoffConfig;
    /**
     * 
     * @type {Array<LeagueDivisionResponse>}
     * @memberof LeagueResponse
     */
    divisions?: Array<LeagueDivisionResponse>;
    /**
     * 
     * @type {number}
     * @memberof LeagueResponse
     */
    teamSize?: number;
    /**
     * 
     * @type {number}
     * @memberof LeagueResponse
     */
    maxTeams?: number;
    /**
     * 
     * @type {number}
     * @memberof LeagueResponse
     */
    minTeams?: number;
    /**
     * 
     * @type {boolean}
     * @memberof LeagueResponse
     */
    requiresApproval?: boolean;
    /**
     * 
     * @type {number}
     * @memberof LeagueResponse
     */
    registrationDeadline?: number;
    /**
     * 
     * @type {Array<LeagueMatchdayResponse>}
     * @memberof LeagueResponse
     */
    matchdays?: Array<LeagueMatchdayResponse>;
    /**
     * 
     * @type {Array<LeagueStanding>}
     * @memberof LeagueResponse
     */
    standings?: Array<LeagueStanding>;
    /**
     * 
     * @type {number}
     * @memberof LeagueResponse
     */
    teamsCount?: number;
    /**
     * 
     * @type {number}
     * @memberof LeagueResponse
     */
    currentMatchday?: number;
    /**
     * 
     * @type {LeagueStatus}
     * @memberof LeagueResponse
     */
    status?: LeagueStatus;
    /**
     * Cheat-filtering match-bracketing gate — requires active Match Start / Round Start in Redis to score
     * @type {boolean}
     * @memberof LeagueResponse
     */
    requireActiveMatch?: boolean;
    /**
     * IDs of EventPipelineFilter documents applied to this league's events. Layered on top of the game-wide global filter; blocks when any assigned filter votes BLOCK (conditions AND-compose within each filter; exclude conditions block on match, include conditions block on non-match).
     * @type {Array<string>}
     * @memberof LeagueResponse
     */
    appliedFilterIds?: Array<string>;
    /**
     * Break-glass per-entity exclusions of GLOBAL filters for this league (PRODUCT_PLAN D2(b)). Each entry names one global filter this league opts out of, with a required reason and a required absolute expiry. Evaluated as set membership against the blocking-filter ids stamped on the fan-out message; expiry is enforced at read.
     * @type {Array<GlobalFilterExclusion>}
     * @memberof LeagueResponse
     */
    excludedGlobalFilters?: Array<GlobalFilterExclusion>;
    /**
     * Rule 4 opt-out. When true this league still scores events whose match context is missing (the pre-Rule-4 behavior). Default false — a league that declares what counts should not score events that cannot prove they qualify.
     * @type {boolean}
     * @memberof LeagueResponse
     */
    failOpenOnMissingContext?: boolean;
    /**
     * 
     * @type {string}
     * @memberof LeagueResponse
     */
    createdBy?: string;
    /**
     * 
     * @type {string}
     * @memberof LeagueResponse
     */
    competitionId?: string;
    /**
     * 
     * @type {number}
     * @memberof LeagueResponse
     */
    createdAt?: number;
    /**
     * 
     * @type {number}
     * @memberof LeagueResponse
     */
    updatedAt?: number;
}



/**
 * Check if a given object implements the LeagueResponse interface.
 */
export function instanceOfLeagueResponse(value: object): value is LeagueResponse {
    return true;
}

export function LeagueResponseFromJSON(json: any): LeagueResponse {
    return LeagueResponseFromJSONTyped(json, false);
}

export function LeagueResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeagueResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'gameId': json['gameId'] == null ? undefined : json['gameId'],
        'matchModeId': json['matchModeId'] == null ? undefined : json['matchModeId'],
        'ruleSetId': json['ruleSetId'] == null ? undefined : json['ruleSetId'],
        'sponsorId': json['sponsorId'] == null ? undefined : json['sponsorId'],
        'scoringTemplateId': json['scoringTemplateId'] == null ? undefined : json['scoringTemplateId'],
        'seasonName': json['seasonName'] == null ? undefined : json['seasonName'],
        'seasonNumber': json['seasonNumber'] == null ? undefined : json['seasonNumber'],
        'seasonStartDate': json['seasonStartDate'] == null ? undefined : json['seasonStartDate'],
        'seasonEndDate': json['seasonEndDate'] == null ? undefined : json['seasonEndDate'],
        'roundRobinType': json['roundRobinType'] == null ? undefined : RoundRobinTypeFromJSON(json['roundRobinType']),
        'matchFormat': json['matchFormat'] == null ? undefined : MatchFormatFromJSON(json['matchFormat']),
        'scoringMode': json['scoringMode'] == null ? undefined : MatchScoringModeFromJSON(json['scoringMode']),
        'pointsConfig': json['pointsConfig'] == null ? undefined : LeaguePointsConfigFromJSON(json['pointsConfig']),
        'tiebreakerConfig': json['tiebreakerConfig'] == null ? undefined : TiebreakerConfigFromJSON(json['tiebreakerConfig']),
        'playoffConfig': json['playoffConfig'] == null ? undefined : LeaguePlayoffConfigFromJSON(json['playoffConfig']),
        'divisions': json['divisions'] == null ? undefined : ((json['divisions'] as Array<any>).map(LeagueDivisionResponseFromJSON)),
        'teamSize': json['teamSize'] == null ? undefined : json['teamSize'],
        'maxTeams': json['maxTeams'] == null ? undefined : json['maxTeams'],
        'minTeams': json['minTeams'] == null ? undefined : json['minTeams'],
        'requiresApproval': json['requiresApproval'] == null ? undefined : json['requiresApproval'],
        'registrationDeadline': json['registrationDeadline'] == null ? undefined : json['registrationDeadline'],
        'matchdays': json['matchdays'] == null ? undefined : ((json['matchdays'] as Array<any>).map(LeagueMatchdayResponseFromJSON)),
        'standings': json['standings'] == null ? undefined : ((json['standings'] as Array<any>).map(LeagueStandingFromJSON)),
        'teamsCount': json['teamsCount'] == null ? undefined : json['teamsCount'],
        'currentMatchday': json['currentMatchday'] == null ? undefined : json['currentMatchday'],
        'status': json['status'] == null ? undefined : LeagueStatusFromJSON(json['status']),
        'requireActiveMatch': json['requireActiveMatch'] == null ? undefined : json['requireActiveMatch'],
        'appliedFilterIds': json['appliedFilterIds'] == null ? undefined : json['appliedFilterIds'],
        'excludedGlobalFilters': json['excludedGlobalFilters'] == null ? undefined : ((json['excludedGlobalFilters'] as Array<any>).map(GlobalFilterExclusionFromJSON)),
        'failOpenOnMissingContext': json['failOpenOnMissingContext'] == null ? undefined : json['failOpenOnMissingContext'],
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'competitionId': json['competitionId'] == null ? undefined : json['competitionId'],
        'createdAt': json['createdAt'] == null ? undefined : json['createdAt'],
        'updatedAt': json['updatedAt'] == null ? undefined : json['updatedAt'],
    };
}

export function LeagueResponseToJSON(json: any): LeagueResponse {
    return LeagueResponseToJSONTyped(json, false);
}

export function LeagueResponseToJSONTyped(value?: LeagueResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
        'gameId': value['gameId'],
        'matchModeId': value['matchModeId'],
        'ruleSetId': value['ruleSetId'],
        'sponsorId': value['sponsorId'],
        'scoringTemplateId': value['scoringTemplateId'],
        'seasonName': value['seasonName'],
        'seasonNumber': value['seasonNumber'],
        'seasonStartDate': value['seasonStartDate'],
        'seasonEndDate': value['seasonEndDate'],
        'roundRobinType': RoundRobinTypeToJSON(value['roundRobinType']),
        'matchFormat': MatchFormatToJSON(value['matchFormat']),
        'scoringMode': MatchScoringModeToJSON(value['scoringMode']),
        'pointsConfig': LeaguePointsConfigToJSON(value['pointsConfig']),
        'tiebreakerConfig': TiebreakerConfigToJSON(value['tiebreakerConfig']),
        'playoffConfig': LeaguePlayoffConfigToJSON(value['playoffConfig']),
        'divisions': value['divisions'] == null ? undefined : ((value['divisions'] as Array<any>).map(LeagueDivisionResponseToJSON)),
        'teamSize': value['teamSize'],
        'maxTeams': value['maxTeams'],
        'minTeams': value['minTeams'],
        'requiresApproval': value['requiresApproval'],
        'registrationDeadline': value['registrationDeadline'],
        'matchdays': value['matchdays'] == null ? undefined : ((value['matchdays'] as Array<any>).map(LeagueMatchdayResponseToJSON)),
        'standings': value['standings'] == null ? undefined : ((value['standings'] as Array<any>).map(LeagueStandingToJSON)),
        'teamsCount': value['teamsCount'],
        'currentMatchday': value['currentMatchday'],
        'status': LeagueStatusToJSON(value['status']),
        'requireActiveMatch': value['requireActiveMatch'],
        'appliedFilterIds': value['appliedFilterIds'],
        'excludedGlobalFilters': value['excludedGlobalFilters'] == null ? undefined : ((value['excludedGlobalFilters'] as Array<any>).map(GlobalFilterExclusionToJSON)),
        'failOpenOnMissingContext': value['failOpenOnMissingContext'],
        'createdBy': value['createdBy'],
        'competitionId': value['competitionId'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
    };
}

